import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import { AspectRatio } from 'react-aspect-ratio';
import styled from 'styled-components';
import { Section, Container } from 'components/shared';
import { isValidTitle } from 'utils/validateTitle';

import loadable from '@loadable/component';
const CommunitiesMap = loadable(() =>
  import('components/components/organisms/CommunitiesMap'),
);
const Heading = loadable(() => import('components/components/atoms/Heading'));
const Copy = loadable(() => import('components/components/atoms/Copy'));

const StyledSection = styled(Section)`
  padding-top: 0 !important;
  ${({ isMobile }) =>
    isMobile
      ? 'padding-bottom: 0 !important;'
      : 'padding-bottom: 0.625rem !important;'}
`;

const getItems = (categories) => {
  if (categories && categories.length > 0) {
    const items = [];
    for (let i = 0; i < categories.length; i++) {
      const communities = categories[i].communities;
      for (let c = 0; c < communities.length; c++) {
        items.push({
          ...communities[c],
          communityCardIcon: categories[i].communityCardIcon,
          mapIcon: categories[i].mapIcon,
        });
      }
    }
    const latLongFilter = items.filter(
      (item) => item.latitude && item.longitude,
    );
    return latLongFilter;
  }
  return [];
};

const CommunityMap = ({ fields }) => {
  const title = getFieldValue(fields, 'title');
  const copy = getFieldValue(fields, 'text');
  const categories = getFieldValue(fields, 'categories');

  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);

  const items = getItems(categories);

  return (
    <StyledSection tabIndex='-1' className='focus:outline-none'>
      <Container className='items-right'>
        {isValidTitle(title) && (
          <Heading
            as='h2'
            color={'blue'}
            className='text-4xl leading-10 text-center'
          >
            {title}
          </Heading>
        )}
        {
          <div className='mb-4'>
            <Copy color={'blue'} className='text-xl text-center px-10 md:px-64'>
              {copy}
            </Copy>
          </div>
        }

        <AspectRatio
          ratio={isMobile ? '375/710' : '1200/750'}
          className='w-full'
        >
          {items && items.length > 0 && (
            <div className='w-auto'>
              <CommunitiesMap items={items} />
            </div>
          )}
        </AspectRatio>
      </Container>
    </StyledSection>
  );
};

export default CommunityMap;
